import Product from '@src/quince-site-common/src/domains/Product'
import { ContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder'

import { TPDPSectionData } from '../types/pdp-section-data.type'

export interface ProductPageContext {
  product: Product
  sectionData: TPDPSectionData
}

export interface ProductPageBFFResponse {
  product: Product
  sectionData: TPDPSectionData
}

export const getMiniPDPContext = ({ product, sectionData }: ProductPageBFFResponse): ProductPageContext => {
  return {
    product,
    sectionData,
  }
}

export default ProductPageContext

export { ContainerConfig }
